// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3oz2w","topBottomGutter":"Layout_topBottomGutter__7jToa"};